/**
 * Same wire values as hotels-service and mango-api. The hotels-service spec's
 * description text lists 2 and 3 the other way round; the service code does not.
 */
export enum HospitalityRoomStatus {
  DIRTY = 0,
  CLEAN = 1,
  OCCUPIED = 2,
  INSPECTED = 3,
}

export interface RoomStatusConfig {
  label: string
  /** Semantic palette for StatusBadge. Tiles and status buttons keep the custom fields below. */
  colorPalette: string
  bg: string
  bgDark: string
  border: string
  borderDark: string
  text: string
  textDark: string
  subtleBg: string
  subtleBgDark: string
  subtleBorder: string
  subtleBorderDark: string
}

/**
 * Color mapping matches legacy Hotels UI:
 *   DIRTY     → Red    (#d9534f)
 *   CLEAN     → Yellow (#f0ad4e)  — using orange palette for Chakra UI
 *   OCCUPIED  → Blue   (#337ab7)
 *   INSPECTED → Green  (#5cb85c)
 */
export const ROOM_STATUS_CONFIG: Record<
  HospitalityRoomStatus,
  RoomStatusConfig
> = {
  [HospitalityRoomStatus.DIRTY]: {
    label: 'Dirty',
    colorPalette: 'red',
    bg: 'red.50',
    bgDark: 'red.900',
    border: 'red.300',
    borderDark: 'red.400',
    text: 'red.700',
    textDark: 'red.200',
    subtleBg: 'red.100',
    subtleBgDark: 'red.900',
    subtleBorder: 'red.200',
    subtleBorderDark: 'red.500',
  },
  [HospitalityRoomStatus.CLEAN]: {
    label: 'Clean',
    colorPalette: 'orange',
    bg: 'orange.50',
    bgDark: 'orange.900',
    border: 'orange.300',
    borderDark: 'orange.400',
    text: 'orange.700',
    textDark: 'orange.200',
    subtleBg: 'orange.100',
    subtleBgDark: 'orange.900',
    subtleBorder: 'orange.200',
    subtleBorderDark: 'orange.500',
  },
  [HospitalityRoomStatus.OCCUPIED]: {
    label: 'Stay',
    colorPalette: 'blue',
    bg: 'blue.50',
    bgDark: 'blue.900',
    border: 'blue.300',
    borderDark: 'blue.400',
    text: 'blue.700',
    textDark: 'blue.200',
    subtleBg: 'blue.100',
    subtleBgDark: 'blue.900',
    subtleBorder: 'blue.200',
    subtleBorderDark: 'blue.500',
  },
  [HospitalityRoomStatus.INSPECTED]: {
    label: 'Inspected',
    colorPalette: 'green',
    bg: 'green.50',
    bgDark: 'green.900',
    border: 'green.300',
    borderDark: 'green.400',
    text: 'green.700',
    textDark: 'green.200',
    subtleBg: 'green.100',
    subtleBgDark: 'green.900',
    subtleBorder: 'green.200',
    subtleBorderDark: 'green.500',
  },
}
